<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
					<c-form-item type="hidden" name="stationed_id"></c-form-item>
					<c-form-item type="input" label="所属经销商" name="company_name" readonly @click="$refs.stationedSelector.open(2)"></c-form-item>
					<c-form-item type="checkbox" label="类型" name="types" :options="productTypeData"></c-form-item>
					<c-form-item type="checkbox" label="定制" name="customs" :options="iscustomData" v-if="systemConfig.product_custom == 'ON'"></c-form-item>
					<c-form-item type="select" label="商品类目" name="product_type_id" options="PRODUCT_CLASSIFY"></c-form-item>
					<c-form-item type="input" label="货号" name="product_itemnumber"></c-form-item>
					<c-form-item type="input" label="商品名称" name="product_name"></c-form-item>
					<c-form-item type="datetime" label="上下架时间" start-name="sell_state_start_date" end-name="sell_state_end_date"></c-form-item>
					<c-form-item type="checkbox" name="state" :options="productState"></c-form-item>
				</c-form>
			</m-search>
			
			
			<c-table ref="table" >
				<c-table-column
					type="selector"
				></c-table-column>
				
				<c-table-column
					label="状态"
					name="state"
					width="60"
				>
					<template v-slot="{data}">
						<span v-if="data.state == 0" style="color:red">{{productStateName[data.state]}}</span>
						<span v-if="data.state == 1" style="color:#999999">{{productStateName[data.state]}}</span>
						<span v-if="data.state == 2" style="color:green">{{productStateName[data.state]}}</span>
						<span v-if="data.state == 3" style="color:blue">{{productStateName[data.state]}}</span>
						<span v-if="data.state == 4" style="color:red">{{productStateName[data.state]}}</span>
					</template>
				</c-table-column>
				
				<!-- <c-table-column
					label="货号"
					name="product_itemnumber"
				></c-table-column> -->
				
				<c-table-column
					label="经销商名称"
					name="stationed_name"
					width="150"
				></c-table-column>
				
				<c-table-column
					label="商品信息"
					name="product_name"
					width="350"
				>
					<template v-slot="{data}">
						<product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
						<product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
					</template>
				</c-table-column>
				
				<c-table-column
					label="类型"
					width="60"
					name="platfrom_product_id"
				>
					<template #default="{data}">
						<span v-if="data.platfrom_product_id" style="color:blue">分销</span>
						<span v-else style="color:#999">自建</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="定制"
					width="60"
					name="is_custom"
					v-if="systemConfig.product_custom == 'ON'"
				>
					<template #default="{data}">
						<span v-if="data.is_custom == 1" style="color:blue">支持</span>
						<span v-else style="color:#999">不支持</span>
					</template>
				</c-table-column>
				
				<!-- <c-table-column
					label="商品卖点"
					name="product_subtitle"
					width="100"
				></c-table-column> -->
				
				<c-table-column
					label="所属类目"
					name="product_type_full_name"
					width="200"
				></c-table-column>
				
				<c-table-column
					label="售价(元)"
					name="product_price"
					width="140"
				>
					<template v-slot="{data}">
						￥{{data.product_price}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="发货地"
					name="product_delivery_address_name"
					width="80"
				></c-table-column>
				
				<c-table-column
					label="创建时间"
					name="create_date"
					width="140"
				></c-table-column>
				
				<c-table-column
					label="上下架时间"
					name="sell_state_date"
					width="140"
				></c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="80"
				>
            <template v-slot="{data}">
              <c-table-button @click="navigateTo(`/product_detail/${data.product_id}`)">查看</c-table-button>
            </template>
				</c-table-column>
			</c-table>
		</module>
		
		<stationed-selector ref="stationedSelector" @resolve="selectStationed"></stationed-selector>

    </page>
</template>

<script>
	import productInfo from '@/components/public/product_info.vue'
	import stationedSelector from '@/components/service/stationed_selector.vue'  // 商家库
	import {mapState} from 'vuex'
	
	export default {
		name: 'm_seller_product_list',
		
		components: {
			productInfo,
			stationedSelector,
		},
		
		data() {
			return {
				productState: [{
					name: '草稿',
					value: 0
				}, {
					name: '上架',
					value: 2
				}, {
					name: '下架',
					value: 1
				}],
				productTypeData: [{
					name: '自建',
					value: '1'
				}, {
					name: '分销',
					value: '2',
				}],
				iscustomData: [{
					name: '支持',
					value: '1'
				}, {
					name: '不支持',
					value: '0'
				}],
				
				productClassify: [
					[], [], []
				],
				currentClassify: [],
				classifySearch: [],
				currentClassifyId: '',
				flushImportHisTableTimer: null,
				productTagList: [],
				currentProductTag: []
			}
		},
		
		computed: {
			...mapState(['systemConfig']),
			...mapState({
				productStateName: state => state.dict.productState
			})
		},
		
		mounted() {
			this.$refs.search.search();
			
			this.$bus.$on('productList.update', page => {
				this.$refs.table.update(page);
			});
		},
		
		methods: {
			searchHandle(data) {
				data.stationed_type = 2;
				this.$refs.table.load({
					url: '/product/list',
					data
				});
			},
			
			selectStationed(data) {
				this.$refs.searchForm.set({
					stationed_id: data[0].id,
					company_name: data[0].company_name
				});
			}
        }
	}
</script>

<style lang="stylus" scoped>
	.classify-select {
		padding: 10px;
		
		dl {
			width: 240px;
			border: 1px solid #ddd;
			
			&:nth-child(n+2) {
				border-left: none;
			}
			
			dt {
				position: relative;
				padding: 10px;
			
				.tf {
					position: absolute;
					width: 30px;
					line-height: 36px;
					font-size: 14px;
					text-align: center;
					color: #bbb;
				}
				
				input {
					box-sizing: border-box;
					width: 100%;
					height: 36px;
					border: none;
					padding: 0 10px 0 30px;
					background: #F5F5F5;
				}
			}
			
			dd {
				height: 290px;
				overflow: auto;
				
				li {
					padding: 0 14px;
					line-height: 36px;
					font-size: 13px;
					cursor: pointer;
					
					&:hover,
					&.z-crt {
						background: #FFF17E;
					}
				}
			}
		}
	}
	
	.tag {
		&-list {
			padding: 20px 20px 20px 10px;
		}
		
		&-item {
			margin-left: 10px;
		}
		
		&-img {
			height: 20px;
		}
		
		&-text {
			border: 1px solid #000;
			padding: 0 6px;
			line-height: 18px !important;
			font-size: 12px;
			font-weight: normal !important;
			color: #000;
		}
	}
</style>